import css from './row.scss';

export default rendererMode => {
    if (rendererMode !== null) return;

    return {
        css
    };
};